import { create } from "zustand";
import { toastError, toastSuccess } from "../../Helpers/toasts";
import MainGroupsRepository from "../../Repositories/Groups/MainGroupsRepository";
import FinishedStudentsRepository from "../../Repositories/Reports/FinishedStudentsRepository";

export const useFinishedStudents = create((set, get) => ({
  results: null,
  studentId: null,
  absences_count: null,
  branches: null,
  startDate: null,
  endDate: null,
  pagination: null,
  isLoading: false,
  queryParams: {
    page: 1,
  },

  setLoading: (status) => {
    set({
      isLoading: status,
    });
  },

  updateParams: (paramItem) => {
    set((prevState) => ({
      queryParams: { ...prevState.queryParams, ...paramItem },
    }));
  },

  getBranches: async () => {
    const { data, status } = await MainGroupsRepository.getAllBranches()
    if (status) {
      set({
        branches: data,
      })
    }
  },
  onReload: async (queryString = "") => {
    const { data, status, nonFieldErrors } =
      await FinishedStudentsRepository.studentsList(queryString);
    if (status) {
      set({
        results: data.students,
        absences_count: data.students_count,
        queryParams: { page: 1 },
        pagination: { page_count: data.pagination.page_count || 1 },

      });
    } else toastError(nonFieldErrors);
  },

  loadItems: async (queryString) => {
    const { data, status, nonFieldErrors } =
      await FinishedStudentsRepository.studentsList(queryString);
    if (status) {
      set({
        results: data.students,
        absences_count: data.students_count,
        pagination: { page_count: data.pagination.page_count || 1 },
      });
    } else toastError(nonFieldErrors);
  },
  onSubmit: async (value) => {
    const { data, status, nonFieldErrors } =
      await FinishedStudentsRepository.submitScore(value);
    if (status) {
      toastSuccess("Saqlandi");
    } else toastError(nonFieldErrors);
  },
}));
